var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventAction, NewsletterSignupEvent, NewsletterSignupName, } from '../../../enums/Tracking';
export var getTrackingData = function (_a) {
    var event = _a.event, tracking = _a.tracking, visitorHash = _a.visitorHash;
    return ({
        event: event,
        eventAction: event === NewsletterSignupEvent.NewsLetterSignUpClick
            ? EventAction.Click
            : EventAction.Success,
        eventCategory: 'newsletter',
        eventData: __assign(__assign({ name: (tracking && tracking.name) || NewsletterSignupName.NewsletterSignUp }, tracking), (visitorHash && { visitorHash: visitorHash })),
    });
};
